import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, KeyValuePair } from '../../models';
import { IStoreService } from '../../services';
import { guidEmpty } from '../../common';
import { Unsubscribe } from 'redux';
import { StoreElement, Store } from '../../stateManagement';

class TypeSelectController implements angular.IComponentController {
    allowUndefined: boolean;
    allowEmpty: boolean;
    disabled: boolean;
    field: string;
    formController: angular.IFormController;
    hasSubtypes: boolean;
    hasQualifiers: boolean;
    isLoading: boolean;
    loadingMessage: string;
    onChange: ({ type: string }) => any;
    model: string;
    properties: KeyValuePair<string, string>[];

    private _unsubscribe: Unsubscribe;

    static $inject = ['$timeout', 'storeService'];

    constructor(
        private _$timeout: angular.ITimeoutService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        if (!this.field) {
            this.field = 'typeProperty';
        }

        this._unsubscribe = this._storeService.register(
            s => this.initStore(s),
            [StoreElement.Variables]
        );
    }

    $onDestroy() {
        this._unsubscribe();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['disabled'] && this.formController) {
            this.validateType(this.model);
        }
    }

    change() {
        if (this.validateType(this.model)) {
            if (this.onChange) {
                this.onChange({ type: this.model });
            }
        }
        this.validateType(this.model);
    }

    private initStore(store: Store): void {
        const props = _.values(store.variablesTypes.dictionary)
            .map(v => { return { key: v.guid, value: v.name }; });

        if (this.allowUndefined) {
            props.unshift({ key: undefined, value: 'None' });
        }
        if (this.allowEmpty) {
            props.unshift({ key: guidEmpty, value: 'None' });
        }
        this.properties = props;
        this._$timeout(() => this.validateType(this.model));
    }

    private validateType(typeGuid: string): boolean {
        const isValid = !!this.disabled
            || !!this.allowEmpty
            || (!!typeGuid && typeGuid !== guidEmpty && typeGuid.length > 0)
            || (!!this.properties && (this.properties.length === 0 || _.some(this.properties, p => p.key === typeGuid)));
        this.formController[this.field]?.$setValidity('required', isValid);
        return isValid;
    }
}

export const wtTypeSelect: ComponentDefinition = {
    componentId: 'wtTypeSelect',
    controller: TypeSelectController,
    template: require('./typeSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        formController: '<',
        field: '@',
        hasSubtypes: '=?',
        hasQualifiers: '=?',
        allowEmpty: '=?',
        allowUndefined: '=?',
        disabled: '<?',
        onChange: '&?',
    }
};